module.exports = __webpack_public_path__ + "img/rongYu8.d5898079.png";